import { Injectable } from '@angular/core'
import { CommonService } from '../../../shared/services/common.service';

@Injectable({
  providedIn: 'root',
})

export class FaqService {

  constructor( private commonService: CommonService  ) {}

  getFAQ() {
    const urlParam = ['faq']
    const apiParams = {
      fields: 'DEFAULT',
    }
    
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url, apiParams)
  }


}
